module.exports = __webpack_public_path__ + "static/media/ic_dealer_support.54ca0908.svg";